export default "__VITE_ASSET__DujI9piK__"